var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mdContent)?_c('type-wrapper',{staticClass:"type-R",attrs:{"limit":"","bgUrl":_vm.showData.image}},[_c('markdown-it-vue-light',{attrs:{"content":_vm.mdContent}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }